<template>
  <div>
    <router-link to="/act4/main">
      <div class="main" style="background-image:url(static/img/act/4/banner/bg-v2.jpg)" >
        <img class="act-4-banner-swallow fen-up-down" src="static/img/act/4/banner/swallow.png" /> 
        <img class="act-4-banner-boats boats-up-down" src="static/img/act/4/banner/boats.png" /> 
        <img class="act-4-banner-go go-tada" src="static/img/act/4/banner/go.png" />
      </div>
    </router-link>    
  </div>
</template>
 

<script>
//动画
import Velocity from "velocity-animate";

export default {
  name: "Act4Banner",
  components: {
  },
  data() {
    return {
    };
  },
  mounted() {},
  created() {
    this.setDocumentV2(
      "三月三，去撒欢",
      "",
      "https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/static/img/act/4/share.jpg?v=2"
    );
    _czc.push(['_trackEvent', '三月三，去撒欢', '点击', 'Banner页面','0','4']);
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {
  position: absolute;
  width: 100%;
  height: 100%;
  background-position: 50% !important;
  background-size: cover !important;
} 

.act-4-banner-go{
 position: absolute;
    width: 12%;
    left: 61%;
    top: 42%;
}

.act-4-banner-boats{
  position: absolute;
      bottom: 1.2rem;
    left: 31%;
    width: 24%;
    
}
.act-4-banner-swallow{
    position: absolute;
    width: 48%;
    left: 13%;
    top: 29%;
}

@-webkit-keyframes tada {
  from {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  10%,
  20% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
  }

  30%,
  50%,
  70%,
  90% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
  }

  40%,
  60%,
  80% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
  }

  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@keyframes tada {
  from {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  10%,
  20% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
  }

  30%,
  50%,
  70%,
  90% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
  }

  40%,
  60%,
  80% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
  }

  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

.go-tada {
  
  -webkit-animation: tada 2000ms ease-in-out alternate infinite;
  -moz-animation: tada 2000ms ease-in-out alternate infinite;
  animation: tada 2000ms ease-in-out alternate infinite;
  animation-delay: 360ms;
  -webkit-animation-delay: 360ms; 
}


.fen {
  pointer-events: auto;
  -webkit-user-select: auto;
}

@-webkit-keyframes frames-up-down {
  0% {
    -webkit-transform: translateY(-10px);
    -webkit-transform-origin: top center;
    -moz-transform: translateY(-10px));
    -moz-transform-origin: top center;
    transform: translateY(-10px);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateY(10px);
    -webkit-transform-origin: top center;
    -moz-transform: translateY(10px);
    -moz-transform-origin: top center;
    transform: translateY(10px);
    transform-origin: top center;
  }
}

@keyframes frames-up-down {
  0% {
    -webkit-transform: translateY(-10px);
    -webkit-transform-origin: top center;
    -moz-transform: translateY(-10px));
    -moz-transform-origin: top center;
    transform: translateY(-10px);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateY(10px);
    -webkit-transform-origin: top center;
    -moz-transform: translateY(10px);
    -moz-transform-origin: top center;
    transform: translateY(10px);
    transform-origin: top center;
  }
}

.fen-up-down {
  -webkit-animation: frames-up-down 2000ms ease-in-out alternate infinite;
  -moz-animation: frames-up-down 2000ms ease-in-out alternate infinite;
  animation: frames-up-down 2000ms ease-in-out alternate infinite;
  animation-delay: 360ms;
  -webkit-animation-delay: 360ms;
}


.boats-up-down {
  -webkit-animation: frames-up-down 3300ms ease-in-out alternate infinite;
  -moz-animation: frames-up-down 3300ms ease-in-out alternate infinite;
  animation: frames-up-down 3300ms ease-in-out alternate infinite;
  animation-delay: 260ms;
  -webkit-animation-delay: 260ms;
}

.go-up-down {
  -webkit-animation: frames-up-down 3300ms ease-in-out alternate infinite;
  -moz-animation: frames-up-down 3300ms ease-in-out alternate infinite;
  animation: frames-up-down 3300ms ease-in-out alternate infinite;
  animation-delay: 260ms;
  -webkit-animation-delay: 260ms;
}

</style>


// WEBPACK FOOTER //
// src/components/act/4/Banner.vue